import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selector as createQuickAlertsApi } from './createQuickAlerts/createQuickAlertsSlice';
import { Status } from "../../../common/constants";
import { useSpinner } from "../../../customHooks";
import { fetchQuickAlertsData } from "./listQuickAlerts/listQuickAlertsSlice";
import { actions as modalActions } from '../../../components/modals/createAlert/createEditAlertModalSlice';
import {QUICK_ALERT_PAGE_LIMIT} from "../../../common/constants";
const useQuickAlerts = () => {
    const dispatch: any = useDispatch();
    const createQuickAlertsAlertResponse = useSelector(createQuickAlertsApi);

    useSpinner(createQuickAlertsAlertResponse.status);

    const showModal = (): void => {
        dispatch(modalActions.turnOnQuickAlertMode());
        dispatch(modalActions.showModal());
    }

    return {
        showModal
    }

}

export default useQuickAlerts;